import { useFlags as useLDFlags } from "launchdarkly-react-client-sdk";
import { FlagNames, Flags } from "./flags";
import { getOverriddenFlags } from "./getOverriddenFlags";

/**
 * @returns an object containing all current flags + variations
 *
 * Flag variations can be overridden to preview/force specific flag variations.
 * See `getOverriddenFlags` for details.
 */
export const useFlags = (): Flags => {
  const providedFlags: Flags = useLDFlags();
  const overriddenFlags = getOverriddenFlags();
  return { ...providedFlags, ...overriddenFlags };
};

/**
 * @param name FlagNames
 * @returns the matching flag variation value
 *
 * Flag variations can be overridden to preview/force specific flag variations.
 * See `getOverriddenFlags` for details.
 */
export function useFlag<T extends FlagNames>(name: T): Flags[T] {
  const flags = useFlags();
  return flags[name];
}
